import api from 'api'
import { CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS } from 'api/cacheTagTypes'
import { get } from 'utils/lodash'
import { transformResponse } from 'utils/route'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getRouteStopsUnassigned: build.query({
      query: ({ serviceDate }) => ({
        url: '/api/v1/core/route/stops/unassigned',
        method: 'GET',
        params: { serviceDate },
      }),
      transformResponse: data => {
        const newStops = transformResponse(get(data, 'stops', []))
        return { stops: newStops }
      },
      providesTags: (result, error, body) => (body?.skipCache ? [] : [CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS]),
    }),
  }),
})

export const { useLazyGetRouteStopsUnassignedQuery } = extendedApi

// Cache-result selector for reading loaded unassigned stops outside a component
// (the board search coordinator) — see getRouteStops.js for the rationale.
export const selectGetRouteStopsUnassigned = extendedApi.endpoints.getRouteStopsUnassigned.select
